export enum TargetSystem {
  AssetManagement = 'AssetManagement',
  CoreApi = 'CoreApi',
  Core = 'Core'
}

export const enum AccessArea {
  Administrator = 'Administrator',
  Project = 'ProjectsModule',
  Product = 'ProductSponsor',
  AssetManagement = 'AssetManagement',
  BulkPayment = 'BulkPayment',
  SystemAdministrator = 'UnifiiAdmin'
}

export const enum AccessRight {
  Executive = 'Executive',
  ViewOnly = 'ViewOnly',
  Basic = 'Basic',
  ViewAll = 'ViewAll'
}

export enum FieldState {
  Ok = 'ok',
  Error = 'error'
}

export enum MeterType {
  Solar = 'SolarMeter',
  Generator = 'GeneratorMeter',
  Grid = 'GridMeter',
  VirtualSolar = 'VirtualSolarMeter',
  VirtualGrid = 'VirtualGridMeter',
}

// TODO Remove this from Asset Management
/** @deprecated Use `/shared/constants#MeterType` rather. This is provided for places where we're not using the string enum value yet. */
export enum MeterTypeNumeric {
  Solar = 1,
  Generator = 2,
  Grid = 3,
  VirtualSolar = 4,
  VirtualGrid = 5,
}
